export default __webpack_public_path__ + "static/media/05-professional.f2b4cdda.jpg";